import WorkerIcon from '@mui/icons-material/Storage';

import WorkerList from './WorkerList';
import WorkerCreate from './WorkerCreate';
import WorkerEdit from './WorkerEdit';

const resource = {
    list: WorkerList,
    create: WorkerCreate,
    edit: WorkerEdit,
    icon: WorkerIcon,
};

export default resource;
